import { fetcher } from '@commenda/utils';
import {
  TIndirectTaxCustomerBulkActionParams,
  TIndirectTaxCustomerSendExemptionInvitationResponse,
} from './types';

export async function sendIndirectTaxExemptionRequest(
  body: TIndirectTaxCustomerBulkActionParams
): Promise<{
  success: boolean;
  error?: string;
  data?: TIndirectTaxCustomerSendExemptionInvitationResponse;
}> {
  try {
    const response = await fetcher(
      'email-campaign/send-invitations',
      {
        method: 'POST',
        body,
      },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to send exemption request email',
      };
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to send exemption request email';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
